import { Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import Message from "../message";

function InstaScraper() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [inputQuery, setInputQuery] = useState({ username: "", hashtag: "", post_url: "" });
  const [statusInputQuery, setStatusInputQuery] = useState("");

  const submit_inputQuery = async () => {
    setStatusInputQuery("");

    if (inputQuery["username"] === "" && inputQuery["hashtag"] === "" && inputQuery["post_url"] === "") {
      setStatusInputQuery("Enter Username, hashtag or post url!");
    }
    else {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: inputQuery["username"],
          hashtag: inputQuery["hashtag"],
          post_url: inputQuery["post_url"]
        }),
      };

      const requestUrl = apiServer + "api/insta_scraper/scrape";

      try {
        const response = await fetch(
          requestUrl,
          requestOptions
        );
        const inputQueryId = await response.json();
        const inputQueryStatus = inputQueryId.detail
          ? inputQueryId.detail
          : inputQueryId;
        setStatusInputQuery(inputQueryStatus);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TextField
        style={{ marginTop: "15px", width: "100%" }}
        value={inputQuery.username}
        onChange={(e) =>
          setInputQuery({ ...inputQuery, username: e.target.value })
        }
        id="outlined-basic"
        label="username"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", width: "100%" }}
        value={inputQuery.hashtag}
        onChange={(e) =>
          setInputQuery({ ...inputQuery, hashtag: e.target.value })
        }
        id="outlined-basic"
        label="hashtag"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", width: "100%" }}
        value={inputQuery.post_url}
        onChange={(e) =>
          setInputQuery({ ...inputQuery, post_url: e.target.value })
        }
        id="outlined-basic"
        label="post_url"
        variant="filled"
      />
      <br/>
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => submit_inputQuery()}
      >
        Submit
      </Button>
      {Message(statusInputQuery, setStatusInputQuery)}
    </div>
  );
}

export default InstaScraper;
